export default {

    set: function(cname, cvalue, extime = null) {
        if (extime === null) {
            // 10 years
            extime = Date.now() + (10 * 365 * 24 * 60 * 60);
        }
        let d = new Date();
        let expires_time = (d.getTime() + parseInt(extime));
        d.setTime(expires_time);
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },

    get:function(cname){
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    },
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/CookieService.js